export default {
    actions: {},
    errors: {},
    directions: {},
    inputs: {},
};
